import { AlignmentType, BorderStyle, Paragraph, ShadingType, Table, TableCell, TableRow, TextRun, WidthType } from "docx";

export const OwaspBullet = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    indent: { left: 1200, right: 600 },
    spacing: { line: 350, before: 20 * 72 * 0.1, after: 20 * 72 * 0.05 },
    alignment: AlignmentType.JUSTIFIED,
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "OWASP Standards ",
            font: "Calibri",
            color: '0f0f3f',
            italics: false
        }),
    ],
})

export const toolsTable = new Table({
    width: { size: 89, type: WidthType.PERCENTAGE },
    alignment: AlignmentType.CENTER,
    spacing: { before: 1200 },
    borders: {
        top: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
        bottom: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
        left: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
        right: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
    },
    rows: [
        new TableRow({
            children: [
                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 80, after: 80 },
                            indent: { left: 100, right: 100 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "#",
                                    font: "Calibri",
                                    size: 22,
                                    color: '#FFFFFF',
                                    italics: false
                                })
                            ]
                        })],
                    shading: { type: ShadingType.SOLID, color: "0189f9" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "0f0f3f" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "0f0f3f" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "0f0f3f" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "0f0f3f" },
                    },
                }),
                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 80, after: 80 },
                            indent: { left: 100, right: 100 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "Frameworks / Methodologies",
                                    font: "Calibri",
                                    size: 22,
                                    color: '#FFFFFF',
                                    italics: false
                                })
                            ]
                        })],
                    shading: { type: ShadingType.SOLID, color: "0189f9" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "0f0f3f" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "0f0f3f" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "0f0f3f" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "0f0f3f" },
                    },
                }),
                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 80, after: 80 },
                            indent: { left: 100, right: 100 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "References",
                                    font: "Calibri",
                                    size: 22,
                                    color: '#FFFFFF',
                                    italics: false
                                })
                            ]
                        })],
                    shading: { type: ShadingType.SOLID, color: "0189f9" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "0f0f3f" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "0f0f3f" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "0f0f3f" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "0f0f3f" },
                    },
                }),
            ]
        }),

        new TableRow({
            children: [
                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 80, after: 80 },
                            indent: { left: 100, right: 100 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "1",
                                    font: "Calibri",
                                    size: 22,
                                    color: '0f0f3f',
                                    italics: false
                                })
                            ]
                        })],
                    shading: { type: ShadingType.SOLID, color: "FFFFFF" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "0f0f3f" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "0f0f3f" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "0f0f3f" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "0f0f3f" },
                    },
                }),
                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 80, after: 80 },
                            indent: { left: 200, right: 200 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "OWASP Compliance Standards",
                                    font: "Calibri",
                                    size: 22,
                                    color: '0f0f3f',
                                    italics: false
                                }),
                            ]
                        })],
                    shading: { type: ShadingType.SOLID, color: "FFFFFF" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "0f0f3f" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "0f0f3f" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "0f0f3f" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "0f0f3f" },
                    },
                }),
                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 80, after: 80 },
                            alignment: AlignmentType.LEFT,
                            children: [
                                new TextRun({
                                    text: "https://www.owasp.org/index.php/Category:OWASP_Code_Review_Project",
                                    font: "Calibri",
                                    size: 22,
                                    color: '0f0f3f',
                                    italics: false
                                }),
                            ]
                        })],
                    shading: { type: ShadingType.SOLID, color: "FFFFFF" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "0f0f3f" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "0f0f3f" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "0f0f3f" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "0f0f3f" },
                    },
                }),
            ]
        }),


    ]
})

export const OwaspBulletTwo = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    indent: { left: 1200, right: 600 },
    spacing: { line: 350, before: 350, after: 20 * 72 * 0.05 },
    alignment: AlignmentType.JUSTIFIED,
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "For Automated auditing used the tools mentioned below table",
            font: "Calibri",
            color: '0f0f3f',
            italics: false
        }),
    ],
})

export const auditTools = new Table({
    width: { size: 89, type: WidthType.PERCENTAGE },
    alignment: AlignmentType.CENTER,
    spacing: { before: 1200 },
    borders: {
        top: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
        bottom: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
        left: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
        right: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
    },
    rows: [
        new TableRow({
            children: [
                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 80, after: 80 },
                            indent: { left: 100, right: 100 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "#",
                                    font: "Calibri",
                                    size: 22,
                                    color: '#FFFFFF',
                                    italics: false
                                })
                            ]
                        })],
                    shading: { type: ShadingType.SOLID, color: "0189f9" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "0f0f3f" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "0f0f3f" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "0f0f3f" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "0f0f3f" },
                    },
                }),
                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 80, after: 80 },
                            indent: { left: 100, right: 100 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "Tools",
                                    font: "Calibri",
                                    size: 22,
                                    color: '#FFFFFF',
                                    italics: false
                                })
                            ]
                        })],
                    shading: { type: ShadingType.SOLID, color: "0189f9" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "0f0f3f" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "0f0f3f" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "0f0f3f" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "0f0f3f" },
                    },
                }),
                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 80, after: 80 },
                            indent: { left: 100, right: 100 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "References",
                                    font: "Calibri",
                                    size: 22,
                                    color: '#FFFFFF',
                                    italics: false
                                })
                            ]
                        })],
                    shading: { type: ShadingType.SOLID, color: "0189f9" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "0f0f3f" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "0f0f3f" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "0f0f3f" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "0f0f3f" },
                    },
                }),
            ]
        }),

        new TableRow({
            children: [
                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 80, after: 80 },
                            indent: { left: 100, right: 100 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "1",
                                    font: "Calibri",
                                    size: 22,
                                    color: '0f0f3f',
                                    italics: false
                                })
                            ]
                        })],
                    shading: { type: ShadingType.SOLID, color: "FFFFFF" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "0f0f3f" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "0f0f3f" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "0f0f3f" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "0f0f3f" },
                    },
                }),
                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 80, after: 80 },
                            indent: { left: 200, right: 200 },
                            alignment: AlignmentType.LEFT,
                            children: [
                                new TextRun({
                                    text: "SonarQube",
                                    font: "Calibri",
                                    size: 22,
                                    color: '0f0f3f',
                                    italics: false
                                }),
                            ]
                        })],
                    shading: { type: ShadingType.SOLID, color: "FFFFFF" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "0f0f3f" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "0f0f3f" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "0f0f3f" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "0f0f3f" },
                    },
                }),
                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 80, after: 80 },
                            indent: { left: 70 },
                            alignment: AlignmentType.LEFT,
                            children: [
                                new TextRun({
                                    text: "https://www.sonarqube.org/",
                                    font: "Calibri",
                                    size: 22,
                                    color: '0f0f3f',
                                    italics: false
                                }),
                            ]
                        })],
                    shading: { type: ShadingType.SOLID, color: "FFFFFF" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "0f0f3f" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "0f0f3f" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "0f0f3f" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "0f0f3f" },
                    },
                }),
            ]
        }),
        new TableRow({
            children: [
                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 80, after: 80 },
                            indent: { left: 100, right: 100 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "2",
                                    font: "Calibri",
                                    size: 22,
                                    color: '0f0f3f',
                                    italics: false
                                })
                            ]
                        })],
                    shading: { type: ShadingType.SOLID, color: "FFFFFF" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "0f0f3f" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "0f0f3f" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "0f0f3f" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "0f0f3f" },
                    },
                }),
                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 80, after: 80 },
                            indent: { left: 200, right: 200 },
                            alignment: AlignmentType.LEFT,
                            children: [
                                new TextRun({
                                    text: "Insider",
                                    font: "Calibri",
                                    size: 22,
                                    color: '0f0f3f',
                                    italics: false
                                }),
                            ]
                        })],
                    shading: { type: ShadingType.SOLID, color: "FFFFFF" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "0f0f3f" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "0f0f3f" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "0f0f3f" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "0f0f3f" },
                    },
                }),
                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 80, after: 80 },
                            indent: { left: 70 },
                            alignment: AlignmentType.LEFT,
                            children: [
                                new TextRun({
                                    text: "https://github.com/insidersec/insider",
                                    font: "Calibri",
                                    size: 22,
                                    color: '0f0f3f',
                                    italics: false
                                }),
                            ]
                        })],
                    shading: { type: ShadingType.SOLID, color: "FFFFFF" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "0f0f3f" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "0f0f3f" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "0f0f3f" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "0f0f3f" },
                    },
                }),
            ]
        }),
        new TableRow({
            children: [
                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 80, after: 80 },
                            indent: { left: 100, right: 100 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "3",
                                    font: "Calibri",
                                    size: 22,
                                    color: '0f0f3f',
                                    italics: false
                                })
                            ]
                        })],
                    shading: { type: ShadingType.SOLID, color: "FFFFFF" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "0f0f3f" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "0f0f3f" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "0f0f3f" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "0f0f3f" },
                    },
                }),
                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 80, after: 80 },
                            indent: { left: 200, right: 200 },
                            alignment: AlignmentType.LEFT,
                            children: [
                                new TextRun({
                                    text: "Grep",
                                    font: "Calibri",
                                    size: 22,
                                    color: '0f0f3f',
                                    italics: false
                                }),
                            ]
                        })],
                    shading: { type: ShadingType.SOLID, color: "FFFFFF" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "0f0f3f" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "0f0f3f" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "0f0f3f" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "0f0f3f" },
                    },
                }),
                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 80, after: 80 },
                            indent: { left: 70 },
                            alignment: AlignmentType.LEFT,
                            children: [
                                new TextRun({
                                    text: "NA",
                                    font: "Calibri",
                                    size: 22,
                                    color: '0f0f3f',
                                    italics: false
                                }),
                            ]
                        })],
                    shading: { type: ShadingType.SOLID, color: "FFFFFF" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "0f0f3f" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "0f0f3f" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "0f0f3f" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "0f0f3f" },
                    },
                }),
            ]
        }),


    ]
})

export function weakPoint1(weakPoint) {
    const names = Array.isArray(weakPoint) ? weakPoint : [];
    const rows = [
        new TableRow({
            children: [
                new TableCell({
                    width: { size: 5, type: WidthType.PERCENTAGE },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                    },
                    children: [new Paragraph({
                        spacing: { before: 1, after: 1 },
                        alignment: AlignmentType.CENTER,
                        children: [new TextRun({
                            text: "",
                            font: "Calibri",
                            size: 26,
                            color: '0f0f3f',
                            italics: false
                        })]
                    })],
                }),
                new TableCell({
                    width: { size: 75, type: WidthType.PERCENTAGE },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                    },
                    children: [new Paragraph({
                        spacing: { before: 60, after: 60 },
                        alignment: AlignmentType.LEFT,
                        children: [new TextRun({
                            text: "",
                            font: "Calibri",
                            size: 24,
                            color: '0f0f3f',
                            italics: false
                        })]
                    })],
                }),
            ]
        })
    ];

    names.forEach((name) => {
        rows.push(
            new TableRow({
                children: [
                    new TableCell({
                        width: { size: 5, type: WidthType.PERCENTAGE },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        },
                        children: [new Paragraph({

                            spacing: { before: 60, after: 60 },
                            alignment: AlignmentType.CENTER,
                            children: [new TextRun({
                                text: "\u2022",
                                font: "Calibri",
                                size: 26,
                                color: '0f0f3f',
                                italics: false
                            })]
                        })],
                    }),
                    new TableCell({
                        width: { size: 75, type: WidthType.PERCENTAGE },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        },
                        children: [new Paragraph({
                            spacing: { before: 50, after: 60 },
                            alignment: AlignmentType.LEFT,
                            children: [new TextRun({
                                text: name,
                                font: "Calibri",
                                size: 24,
                                color: '0f0f3f',
                                italics: false
                            })]
                        })],
                    }),
                ]
            })
        );
    });

    return new Table({
        width: { size: 80, type: WidthType.PERCENTAGE },
        alignment: AlignmentType.LEFT,
        spacing: { before: 10 },
        indent: { size: 900, type: WidthType.DXA },
        borders: {
            top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
            bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
            left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
            right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
        },
        rows: rows
    });
}

export function strongPoint1(strongPoint) {

    const names = Array.isArray(strongPoint) ? strongPoint : [];

    const rows = [
        new TableRow({
            children: [
                new TableCell({
                    width: { size: 5, type: WidthType.PERCENTAGE },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                    },
                    children: [new Paragraph({

                        spacing: { before: 1, after: 1 },
                        alignment: AlignmentType.CENTER,
                        children: [new TextRun({
                            text: "",
                            font: "Calibri",
                            size: 26,
                            color: '0f0f3f',
                            italics: false
                        })]
                    })],
                }),
                new TableCell({
                    width: { size: 75, type: WidthType.PERCENTAGE },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                    },
                    children: [new Paragraph({
                        spacing: { before: 60, after: 60 },
                        alignment: AlignmentType.LEFT,
                        children: [new TextRun({
                            text: "",
                            font: "Calibri",
                            size: 24,
                            color: '0f0f3f',
                            italics: false
                        })]
                    })],
                }),
            ]
        })
    ];

    names.forEach((name) => {
        rows.push(
            new TableRow({
                children: [
                    new TableCell({
                        width: { size: 5, type: WidthType.PERCENTAGE },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        },
                        children: [new Paragraph({

                            spacing: { before: 60, after: 60 },
                            alignment: AlignmentType.CENTER,
                            children: [new TextRun({
                                text: "\u2022",
                                font: "Calibri",
                                size: 26,
                                color: '0f0f3f',
                                italics: false
                            })]
                        })],
                    }),
                    new TableCell({
                        width: { size: 75, type: WidthType.PERCENTAGE },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        },
                        children: [new Paragraph({
                            spacing: { before: 60, after: 60 },
                            alignment: AlignmentType.LEFT,
                            children: [new TextRun({
                                text: name,
                                font: "Calibri",
                                size: 24,
                                color: '0f0f3f',
                                italics: false
                            })]
                        })],
                    }),
                ]
            })
        );
    });

    return new Table({
        width: { size: 80, type: WidthType.PERCENTAGE },
        alignment: AlignmentType.LEFT,
        spacing: { before: 10 },
        indent: { size: 900, type: WidthType.DXA },
        borders: {
            top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
            bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
            left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
            right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
        },
        rows: rows
    });
}

